exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".select-product-modal .ivu-checkbox-wrapper{display:inline-block}.select-product-modal .ivu-modal-footer{display:none}", ""]);

// exports
